// src/components/ProductsSorter/ProductSorter.jsx

'use client'

import { useCallback, useState, useMemo } from 'react';
import { useSearchParams, usePathname, useRouter } from 'next/navigation';
import { sorting } from '@/containers/constants';
import {FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import styles from '@/app/[lang]/shop/shop-category.module.scss';


const useUrlParams = () => {

  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const updateParams = useCallback((key, value) => {
    const params = new URLSearchParams(searchParams);
    if (value === null) {
      params.delete(key);
    } else {
      params.set(key, value);
    }
    router.push(`${pathname}?${params.toString()}`);
  }, [searchParams, pathname, router]);

  return { searchParams, updateParams };
};


export default function ProductSorter({ productSorterLabel }) {

  const { searchParams, updateParams } = useUrlParams();
  const [selectedSort, setSelectedSort] = useState(searchParams.get('sort') || 'best-match');

  const handleSortChange = useCallback(event => {
    const { value } = event.target;
    updateParams('sort', value === 'best-match' ? null : value);
    setSelectedSort(value);
  }, [updateParams]);

  const menuItems = useMemo(() =>
    sorting.map(entry => <MenuItem value={entry.slug} key={entry.slug}>{entry.title}</MenuItem>), []
  );

  return (
    <FormControl className={styles.sorterContainer}>
      <InputLabel id="sort-label">{productSorterLabel}</InputLabel>
      <Select
        labelId="sort-label"
        value={selectedSort}
        label={productSorterLabel}
        onChange={handleSortChange}
        variant="outlined"
      >
        {menuItems}
      </Select>
    </FormControl>
  )
}
